export function blobToDataURL(blob: Blob): Promise<string> {
	return new Promise<string>(res => {
		const myReader: FileReader = new FileReader();

		myReader.onloadend = () => res(myReader.result as string);

		myReader.readAsDataURL(blob);
	});
}
